import { render, staticRenderFns } from "./MouseAction.vue?vue&type=template&id=c83b0c3e&scoped=true"
import script from "./MouseAction.vue?vue&type=script&lang=js"
export * from "./MouseAction.vue?vue&type=script&lang=js"
import style0 from "./MouseAction.vue?vue&type=style&index=0&id=c83b0c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83b0c3e",
  null
  
)

export default component.exports